module.exports = {
	"Announcement": {
		"Know More": "Mehr erfahren"
	},
	"Appointment": {
		"Conditions": "Indem Sie auf „Bestätigen“ klicken, geben Sie an, dass Sie die Datenschutzbestimmungen gelesen haben und der Verarbeitung Ihrer persönlichen Daten durch %(brand)s unter den Bedingungen, die in den Datenschutzbestimmungen festgelegt sind, zustimmen.",
		"Confirmation": "Ihre Terminanfrage für einen persönlichen Beratungstermin bei einem unserer Berater in unserer Boutique ist bei uns eingegangen. Sie erhalten in Kürze eine Bestätigungs-E-Mail.",
		"Description": "Dior empfiehlt Ihnen, einen Termin mit einem Berater in der Boutique zu vereinbaren, der Ihnen persönlich hilft.",
		"Get an appointment": "Einen Termin vereinbaren",
		"Motives": "Motive",
		"Universes": "Universum"
	},
	"DiorMap": {
		"Search in this area": "In diesem Bereich suchen"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Ergebnis",
			"other": "%(count)s Ergebnisse",
			"zero": "%(count)s Ergebnis"
		},
		"Refine": "Filtern",
		"RefineAria": "Verfeinern Sie die Suche mit den Kontrollkästchen unten",
		"Are you looking for?": "Sind Sie auf der Suche nach einer Boutique zum Thema Damenmode, Herrenmode, Kindermore, Schmuck und Uhren?"
	},
	"Footer": {
		"Download the applications": "Anwendungen herunterladen",
		"Language": "Sprache",
		"Newsletter": "Z. B.: Christian@dior.fr",
		"Ok": "Ok",
		"Subscribe to newsletter": "Für den Newsletter eintragen"
	},
	"Form": {
		"All fields are mandatory": "Alle Felder sind Pflichtfelder",
		"Civility": "Anrede",
		"Comments": "Anmerkungen",
		"Conditions": "Wenn Sie eine Bestätigungs-E-Mail von %(brand)s wünschen, aktivieren Sie das nachstehende Kästchen. Sie haben das Recht auf Zugang, Berichtigung, Löschung und Widerruf der Verarbeitung der Sie betreffenden Daten. Schreiben Sie dazu an \"contact@dior.com\"",
		"Date": "Wunschdatum ",
		"Email": "E-Mail-Adresse",
		"Hour": "Wunschuhrzeit",
		"Invalid E-mail address": "Ungültige E-Mail-Adresse",
		"Mr": "Hr.",
		"Mrs": "Fr.",
		"Name": "Name",
		"Phone": "Telefon",
		"Required fields": "Benötigte Felder",
		"Submit": "Bestätigen",
		"Surname": "Vorname"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Die Dior Boutique in Ihrer Stadt: haute couture, parfums, lederwaren",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Ankunft",
		"Departure": "Abfahrt",
		"Details": "Details",
		"Error": "Wir können leider zu dieser Anfrage keinen Anfahrtsplan bereit stellen, bitte versuchen Sie es erneut mit einer anderen Adresse und/oder einem anderen Transportmittel",
		"Follow the itinerary": "Wegbeschreibung folgen",
		"Itinerary": "Wegbeschreibung",
		"modeBICYCLING": "Mit dem Fahrrad",
		"modeDRIVING": "Mit dem Auto",
		"modeTRANSIT": "Mit öffentlichen Verkehrsmitteln",
		"modeWALKING": "Zu Fuß",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Bitte verwenden Sie Ihr Telefon im Hochformat"
	},
	"NavMobile": {
		"Home": "Startseite"
	},
	"Newsletter": {
		"Dior Newsletter": "Dior Newsletter",
		"Fashion and accessories": "Mode & Accessoires",
		"I wish to receive the %(newsletter)s newsletter": "Ich möchte News über %(newsletter)s erhalten",
		"Newsletter Confirmation": "Sie sind für den Newsletter eingetragen",
		"Perfume and beauty": "Parfums & Kosmetik",
		"Receive our newsletter": "Abonnieren Sie unseren Newsletter",
		"Your universes": "Unsere Universen"
	},
	"ResultsBlock": {
		"Dior boutiques": "Dior Boutiquen",
		"Too far": "Zu viele ergebnisse, bitte verfeinern sie ihre suche, in dem sie in einem kleineren bereich suchen.",
		"No result": "Es konnte keine Boutique gefunden werden",
		"Other shops": "Weitere Boutiquen",
		"Results": "Suchergebnisse",
		"Fewer results, zoom in": "Weniger ergebnisse, zoom in",
		"More results, zoom out": "Mehr ergebnisse, zoom out",
		"Fewer results": "Weniger ergebnisse",
		"More results": "Mehr ergebnisse"
	},
	"SearchBlock": {
		"Geolocation": "Nutzen Sie die Geolokalisierung, um Boutiquen in Ihrer Nähe zu finden",
		"Search": "Suchen"
	},
	"Share": {
		"Conditions": "Indem Sie auf “Bestätigen“ klicken, geben Sie an, dass Sie die Datenschutzbestimmungen gelesen haben und der Verarbeitung Ihrer persönlichen Daten durch %(brand)s unter den Bedingungen, die in den Datenschutzbestimmungen festgelegt sind, zustimmen. Durch Ankreuzen des entsprechenden Felds stimmen Sie zudem der Verarbeitung Ihrer persönlichen Daten durch Christian Dior Couture für das Direktmarketing zu, welches auf Grundlage Ihrer uns bekannten persönlichen Daten und Präferenzen angepasst wird.",
		"Recipient": "Ihr Empfänger",
		"Share Confirmation": "Die Infos zur Boutique wurden erfolgreich versandt",
		"Share this shop": "Infos zur Boutique teilen",
		"Your favorite shop": "Ihre bevorzugte Boutique"
	},
	"ShopBlock": {
		"Closed": "Geschlossen",
		"Closed today": "Heute geschlossen",
		"Directions": "Wegbeschreibung",
		"DirectionsAria": "Wegbeschreibung zu %(shopName)s",
		"Make an appointment": "Termin vereinbaren",
		"Open": "Offen",
		"Opening time": "Öffnungszeiten",
		"OpeningAria": "Weitere Informationen zu den Öffnungszeiten",
		"ResultNumber": "Ergebnisnummer %(number)s",
		"Services": "Services",
		"ServicesAria": "Weitere Informationen zu den Dienstleistungen",
		"Share": "Teilen",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Heute bis %(hour)s geöffnet",
		"Universes": "Universum",
		"UniversesAria": "Weiter Informationen zu ähnlichen Universen",
		"and": "and",
		"from": "from",
		"publicHolidays": "Die Boutique ist voraussichtlich geschlossen",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/de_de/translations.json
// module id = 857
// module chunks = 0